<div class="container">
  <section class="main">
    <header class="header">
      <mat-icon>donut_large</mat-icon><span>AI Sales Coach</span>
    </header>
    <div class="content">
      <h1>パスキーの認証</h1>
      <p>登録済みのパスキーを使って本人確認を行ってください。</p>
      @if (!supported) {
        <p role="alert">
          このブラウザではパスキーを利用できません。対応ブラウザをご利用ください。
        </p>
      }
      @if (errorMessage) {
        <p role="alert">{{ errorMessage }}</p>
      }
      <button
        rectangle
        [disabled]="busy || !supported || !canRetry"
        (click)="submit()"
      >
        {{
          busy
            ? '処理中…'
            : errorMessage && canRetry
              ? '再試行'
              : 'パスキーで認証'
        }}
      </button>
      <button rectangle variant="secondary" [disabled]="busy" (click)="back()">
        ログインへ戻る
      </button>
    </div>
  </section>
</div>
